/* URL human users should be directed to */
export const ECAMPUS_BASE_URL = 'https://ecampus.uni-koblenz.de';
/* URL API consumers should use */
export const ECAMPUS_WS_BASE_URL = 'https://ecampus-ws.uni-koblenz.de';
export const ECAMPUS_API_URL = ECAMPUS_WS_BASE_URL + '/qisserver/api/v1';
